'use client';

import React, { Suspense, useEffect, useRef, useState } from 'react';
import style from './new-sidebar.module.scss';
import { useAppSelector } from '../../hooks/useAppSelector/UseAppSelector';
import { useIsSidebarOpenSelector } from '../../store/selectors';
import classNames from 'classnames';
import { usePathname } from 'next/navigation';
import dynamic from 'next/dynamic';
type Props = {
  pageType: string | null;
};
const ProducerSidebarDynamic = dynamic(
  () => import('../ClientLayout/Sidebar/Producer/ProducerSidebar'),
  { ssr: false }
);
const NewLandingSidebarDynamic = dynamic(
  () => import('../ClientLayout/Sidebar/Landing/newLandingSidebar'),
  { ssr: false }
);
const MainSidebarLogoDynamic = dynamic(() => import('./MainSidebar'), {
  ssr: false,
});
const LoadingSkeletonDynamic = dynamic(() => import('./loadingSkeleton'), {
  ssr: false,
});
const NewSidebar = ({ pageType }: Props) => {
  const isMenuOpen = useAppSelector(useIsSidebarOpenSelector);
  const pathname = usePathname();
  var eventId = '';
  var channelName = '';

  if (pathname.split('/')[2] === 'event') {
    eventId = pathname.split('/')[1];
    channelName = pathname.split('/')[3];
  }

  const isAdmin = pathname.split('/')[1];
  const isDashboard = pathname.split('/')[2];
  const accessMainSidebar = [
    'landing',
    'categories',
    'event',
    'pricing',
    'terms-of-use',
    'community-guideline',
    'privacy-policy',
    'dmca-policy',
    'cookie-policy',
  ];

  return (
    <div
      className={classNames(style['new-sidebar'], {
        [style['new-sidebar--open']]: isMenuOpen,
        [style['new-sidebar--closed']]: !isMenuOpen,
        [style['new-sidebar--overflow']]: !accessMainSidebar.includes(pageType),
      })}
      suppressHydrationWarning={true}
    >
      <Suspense fallback={<LoadingSkeletonDynamic count={5} />}>
        <MainSidebarLogoDynamic />
        {!['admin'].includes(isAdmin) &&
        !['dashboard'].includes(isDashboard) &&
        accessMainSidebar.includes(pageType) ? (
          <NewLandingSidebarDynamic pageType={pageType} />
        ) : ['dashboard', 'admin'].includes(isAdmin) ||
          ['dashboard'].includes(isDashboard) ? (
          <ProducerSidebarDynamic />
        ) : (
          ''
        )}
      </Suspense>
    </div>
  );
};

export default NewSidebar;
